import { makeStyles } from '@material-ui/core/styles';
import { motionDurationsMs } from 'core/components/theme/motion';

// The full rail needs about 580px at its tallest: the 96px header, two nav groups (~240px), this art (~160px)
// and the user block (~50px). Below 760px the art hides rather than crowd the links or make the nav scroll.
export const NAV_ILLUSTRATION_MIN_VIEWPORT_HEIGHT = 760;

// The policy art's viewBox (with its sky); the generic scene is fitted into the same box.
const ART_ASPECT_RATIO = '293 / 193';

export default makeStyles((theme) => ({
  '@keyframes navArtAssemble': {
    from: { opacity: 0, transform: 'translateY(10px) scale(0.97)' },
    to: { opacity: 1, transform: 'none' }
  },
  // Same keyframes as the gutter art's breeze in layout.styles.js.
  '@keyframes navArtBreeze': {
    '0%, 100%': { transform: 'rotate(0deg)' },
    '30%': { transform: 'rotate(1.4deg)' },
    '65%': { transform: 'rotate(-0.7deg)' }
  },
  // Only the full rail on a tall enough screen; hidden, it takes no space and the user block stays put.
  root: {
    '--motion-duration-illustration': `${motionDurationsMs.illustration}ms`,
    display: 'none',
    margin: theme.spacing(4, 0),
    pointerEvents: 'none',
    userSelect: 'none',
    [`@media (min-width: ${theme.screens.standard_desktop}px) and (min-height: ${NAV_ILLUSTRATION_MIN_VIEWPORT_HEIGHT}px)`]:
      { display: 'block' },
    '@media print': { display: 'none' }
  },
  scene: {
    position: 'relative',
    aspectRatio: ART_ASPECT_RATIO,
    // Motion off, keyboard use and reduced motion zero the root duration tokens, so the art just appears.
    ':root[data-motion="on"] &': {
      animation: '$navArtAssemble var(--motion-duration-open, 0ms) var(--motion-ease-out, ease-out) both'
    }
  },
  art: {
    display: 'block',
    width: '100%',
    height: '100%',
    borderRadius: theme.sizes.roundCorners,
    // The policy art's sky details are styled, not filled, in the SVG (as in the illustrated loader).
    '& .trace': { display: 'none' },
    '& .sun': { fill: theme.colorPalette.orange_50 },
    '& .cloud': { fill: theme.colorPalette.beige_50 },
    '& .bird': {
      fill: 'none',
      stroke: theme.colorPalette.green_100,
      strokeWidth: 1.5,
      strokeLinecap: 'round'
    },
    '& .gutter-tree, & .gutter-leaves, & .gutter-flowers': {
      transformBox: 'fill-box',
      transformOrigin: '50% 100%'
    },
    // One breeze once the art has assembled, paused during keyboard use like the gutter art.
    ':root[data-motion="on"] &': {
      '& .gutter-tree, & .gutter-leaves, & .gutter-flowers': {
        animation: '$navArtBreeze var(--motion-duration-illustration) ease-in-out var(--motion-duration-open, 0ms) 1',
        animationPlayState: 'paused'
      },
      '& .gutter-leaves': { animationDirection: 'reverse' }
    },
    ':root[data-motion="on"][data-input="pointer"] &': {
      '& .gutter-tree, & .gutter-leaves, & .gutter-flowers': { animationPlayState: 'running' }
    },
    '@media (prefers-reduced-motion: reduce)': {
      ':root[data-motion="on"] &': {
        '& .gutter-tree, & .gutter-leaves, & .gutter-flowers': { animation: 'none' }
      }
    }
  },
  umbrella: {
    position: 'absolute',
    top: -theme.spacing(2),
    right: -theme.spacing(1),
    width: 36,
    height: 36
  }
}));
